import { css } from 'astroturf';
import React from 'react';

const styles = css`
  .encircle {
    position: relative;
    display: inline-block;


    & svg {
      position: absolute;
      width: 120%;
      top: 0;
      height: 150%;
      left: -12%;
      z-index: 1;
      margin-top: -5%;
      overflow: visible;
      pointer-events: none;
      stroke: #4ca2cd;
      stroke: oklab(0.61 -0.08 -0.21);
    }
  }
`;

const Circle = ({ children }) => (
  <span className={styles.encircle}>
    <svg width="279" height="80" viewBox="0 0 279 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M141 15.0002C89.3336 11.3335 -10.5997 12.6002 3.00026 47.0002C20.0003 90.0002 242 84 269 59.0002C311.803 19.3676 184 -0.999837 126 2.00016"
        strokeWidth="4"
      />
    </svg>
    <span>{children}</span>
  </span>
);

export default Circle;
